export default {
  namespaced: true,
  state: {
    inviterPhone: '',
    inviterId: '',
    inviteePhone: '',
    reducePrice: null,
  },
  mutations: {
    updateData(state, payload) {
      Object.assign(state, payload);
    },
  },
};
